import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import EmblemsService from "../../services/trainingApi/emblems.service";
import { IEmblemDto } from "../../models/dto/trainingApi/IEmblemDto";
import { Card, CardContent, CardHeader, CardMedia, Grid, IconButton, Typography } from "@mui/material";
import { IconDownload, IconInfo, ProgressIndicator, Tooltip } from "@veneer/core";
import ImageService from "../../services/generalApi/image.service";
import { dateToString2 } from "../../utils/conversion";
import html2canvas from "html2canvas";

export default function Emblems() {
    const [t] = useTranslation("global");
    const [emblems, setEmblems] = useState<IEmblemDto[]>([]);
    const [imagesLoaded, setImagesLoaded] = useState(false)
    const arrayPromises: any[] = [];
    const [blobImages, setBlobImages] = useState<any[]>([]);
    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {
        getEmblems();
    }, [])

    const getEmblems = () => {
        setDataLoaded(false);
        EmblemsService.getEmblems().then(r => {
            setDataLoaded(true);
            setEmblems(r);
        })
    }

    useEffect(() => {
        if (emblems.length > 0) {
            emblems.forEach(emblem => {
                const promise = ImageService.getBlobImage(emblem.emblemImage)
                    .then((r: any) => {
                        let url = URL.createObjectURL(r);
                        return { id: emblem.emblemId, url };
                    });
                arrayPromises.push(promise);
            });

            Promise.all(arrayPromises)
                .then((r) => {
                    setBlobImages(r);
                    setImagesLoaded(true);
                })
                .catch((error: any) => {
                    console.error(error);
                });
        }
    }, [emblems]);

    const getFile = (id: number) => {
        let resourceImage = blobImages.find(x => x.id == id)
        if (resourceImage)
            return resourceImage.url;
        return "";
    }

    const convertToImage = (cardComponent: string, emblemName: string, btnDownload: string) => {
        // Get the card element or any parent container that you want to convert
        const cardElement: HTMLElement = document.getElementById(cardComponent)!;

        const buttonToOmitted: HTMLElement = document.getElementById(btnDownload)!;

        buttonToOmitted.style.display = 'none';
        // Use html2canvas to capture the screenshot of the element
        html2canvas(cardElement)
            .then(canvas => {
                buttonToOmitted.style.display = 'block';

                // Convert the canvas to a data URL
                const dataURL = canvas.toDataURL();
                // Create an anchor element to download the image
                const downloadLink = document.createElement('a');
                downloadLink.href = dataURL;
                downloadLink.download = `${emblemName}.png`;
                downloadLink.click();
            });
    };


    return (
        <div>
            <div style={{ padding: '20px' }}>
                <h4>{t("header.emblems")}</h4>
                <div style={{ padding: '20px' }}>
                    <Grid container spacing={2}>
                        {
                            dataLoaded ?
                                emblems.length > 0 ?
                                    emblems.map((emblem, index) => {
                                        return <Grid item xs={12} sm={6} md={4} key={index}>
                                            <Card
                                                sx={{ maxWidth: 345, minHeight: 345, maxHeight: 370, boxShadow: 3 }}
                                                id={`card-component${index}`}
                                            >
                                                <Typography sx={{ m: 2 }} gutterBottom variant="h6" component="div">
                                                    {emblem.emblemName}
                                                </Typography>
                                                {
                                                    imagesLoaded ? <Tooltip
                                                        content={<>{emblem.emblemName}</>}
                                                        id="tooltip"
                                                        placement="bottom">
                                                        {
                                                            <CardMedia
                                                                sx={{ height: 180, width: 180, m: 2, ml: 10 }}
                                                                image={getFile(emblem.emblemId)}
                                                                title={emblem.emblemName}
                                                            />
                                                        }
                                                    </Tooltip> :
                                                        <div className="container" style={{ height: 140 }}>
                                                            <div className="vertical-center">
                                                                <ProgressIndicator
                                                                    appearance="circular"
                                                                    behavior="indeterminate" />
                                                            </div>
                                                        </div>
                                                }
                                                <CardContent>
                                                    <Typography sx={{ m: 1 }} variant="body2" color="text.secondary">
                                                        {emblem.emblemDescription}
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={10}>
                                                            <Typography sx={{ m: 1 }} variant="body2" color="text.secondary">
                                                                {dateToString2(emblem.emablemDate)}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={2} id={`btnDownload${index}`}>
                                                            <IconButton onClick={() => convertToImage(`card-component${index}`, emblem.emblemName, `btnDownload${index}`)} aria-label="settings">
                                                                <IconDownload />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>;
                                    }
                                    )
                                    :
                                    (
                                        <div className="container" style={{ height: 140 }}>
                                            <div style={{ margin: 'auto', width: '50%', height: '50%', textAlign: 'center' }}>
                                                <IconInfo size={72} />
                                                <br />
                                                <label>{t("header.noEmblems")}</label>
                                            </div>
                                        </div>
                                    )
                                :
                                <div className="container" style={{ height: 180, width: 180 }}>
                                    <div className="vertical-center">
                                        <ProgressIndicator
                                            appearance="circular"
                                            behavior="indeterminate" />
                                    </div>
                                </div>
                        }
                    </Grid>
                </div>
            </div>
        </div>)
}